import { Link } from 'react-router-dom';

import { BrambleMark } from '@/components/bramble-mark';

export function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-border/70">
      <div className="container flex flex-col gap-8 py-12 sm:flex-row sm:items-start sm:justify-between">
        <div className="max-w-sm">
          <div className="flex items-center gap-2.5">
            <BrambleMark className="size-6" />
            <span className="font-display text-lg font-semibold">Bramble</span>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
            A baby tracker that keeps data on your phones. No accounts, ads, tracking, or server
            access to your records.
          </p>
        </div>

        <nav aria-label="Footer" className="flex flex-col gap-2.5 text-sm">
          <Link to="/privacy" className="text-muted-foreground transition-colors hover:text-foreground">
            Privacy policy
          </Link>
          <Link to="/terms" className="text-muted-foreground transition-colors hover:text-foreground">
            Terms of service
          </Link>
          <Link to="/support" className="text-muted-foreground transition-colors hover:text-foreground">
            Support
          </Link>
        </nav>
      </div>

      <div className="container pb-10">
        <p className="kicker">&copy; {new Date().getFullYear()} Bramble &middot; brambleapp.xyz</p>
      </div>
    </footer>
  );
}
